import { getInfo } from '../general.js';
import { getFromUrl } from '../functions.js';

export default async function listFacilities() {
    let facilities;
    const info = getInfo();
    await fetch('/wp-json/facilities_html/v1/facilities', {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
        },
        body: JSON.stringify({ "brand": info.brand, "type": info.type, "pre": getFromUrl('fac') ?? '', "serviceType": getFromUrl('type') ?? '' })
    })
    .then(response => response.json())
    .then(data => {
        facilities = data;
    })
    return facilities;
}
